import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { forkJoin } from 'rxjs';
import { LookupValuesService } from '../../common/lookup-values.service';
import { MemberService } from '../../services/MemberService';


@Injectable({
  providedIn: 'root'
})
export class MemberGetDropdownOptionsResolverService implements Resolve<any>{

  constructor(private lookupvaluesservice: LookupValuesService, private memberService: MemberService) { }

  resolve(route: ActivatedRouteSnapshot) {
      return forkJoin([
          this.lookupvaluesservice.GetMemberTypeOptions(),          
          this.lookupvaluesservice.GetMemberOfficeTypeOptions(),
          this.lookupvaluesservice.GetCountryOptions(),
          this.memberService.GetAllHQAndCorporateOffices()
      ]);
  }
}

@Injectable({
  providedIn: 'root'
})
export class MemberResolverService implements Resolve<any>{

  constructor(private memberService: MemberService) { }

  resolve(route: ActivatedRouteSnapshot) {
      let id = route.paramMap.get('id');
      return this.memberService.GetMemberById(id);
  }
}
@Injectable({
  providedIn: 'root'
})
export class MemberOfficeLocationsResolverService implements Resolve<any>{

  constructor(private memberService: MemberService) { }

  resolve(route: ActivatedRouteSnapshot) {
      let id = route.paramMap.get('id');
      return this.memberService.GetAllOfficeLocations(id);
  }

  
}

@Injectable({
  providedIn: 'root'
})
export class MemberTerritoryResolverService implements Resolve<any>{

  constructor(private memberService: MemberService) { }

  resolve(route: ActivatedRouteSnapshot) {
      let id = route.paramMap.get('id');
      return this.memberService.GetMemberTerritories(id);
  }
}

@Injectable({
  providedIn: 'root'
})
export class MemberTerritoryOptionsResolverService implements Resolve<any>{

  constructor(private lookupvaluesservice: LookupValuesService) { }

  resolve(route: ActivatedRouteSnapshot) {
      return forkJoin([
           this.lookupvaluesservice.GetCountryOptions()        
      ]);
  }
}
